module.exports = __webpack_public_path__ + "static/img/24zaoan.6c171a62.gif";